import { createContext } from 'react';

export interface INewsletterSettings {
    newsletterID: string,
    floating: boolean,
    darkmode: boolean,
    background: boolean,
    buttonColor: string
}

export const NewsletterSettingsDefaults: INewsletterSettings = {
    newsletterID: "",
    floating: false,
    darkmode: false,
    background: false,
    buttonColor: ""
}

export const NewsletterSettingsContext = createContext(NewsletterSettingsDefaults)